import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { ReferenceDataService } from "../services/referencedata.service";

@Injectable()
export class ReasonForMedicationResolve implements Resolve<any> {

    constructor(private refService: ReferenceDataService) {
        
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        return new Promise<any>((resolve, reject) => {
            this.refService.getMedicationReasons().subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
        });

    }

}